import { useUpdateResource } from 'RestAPIs/useUpdateResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useGetAdminSettings } from '../../../../../queries';
import { AdminSettingsResponse } from '../../../../types';
import AbsenceFormContent from './AbsenceFormContent';
import { absenceSchema } from './schema';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { showErrorSnackbar } from 'components/shared/Snackbar';

const Absence = () => {
  const { t } = useTranslation('common');
  const { data: absenceData = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>('absence-procedure', {
      onError: () => showErrorSnackbar(t('absenceProcedure.getError'))
    });

  const { mutate: saveAbsence, isLoading: isLoading } = useUpdateResource({
    url: ADMIN_SETTINGS_GROUP,
    id: absenceData[0]?.groupId,
    invalidateQueryKey: ['absence-procedure'],
    message: {
      success: t('absenceProcedure.putSuccess'),
      error: t('absenceProcedure.putError')
    }
  });

  const data = absenceData[0];

  const submitForm = (formData) => {
    saveAbsence({
      ...data,
      settings: transformAdminSettingsToRequestValues(formData, data.settings)
    });
  };

  const convertedData = transformAdminSettingsToFormValues(data);

  return (
    <AdminSettingsFormWrapper
      submitForm={submitForm}
      schema={absenceSchema(t)}
      isFetching={isFetching}
      isLoading={isLoading}
      data={convertedData}
    >
      <AbsenceFormContent />
    </AdminSettingsFormWrapper>
  );
};

export default Absence;
